import { render, staticRenderFns } from "./ProductionDaysSelector.vue?vue&type=template&id=a24f3c88&"
import script from "./ProductionDaysSelector.vue?vue&type=script&lang=js&"
export * from "./ProductionDaysSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports